export const contractAddress = {
    USDT: '0x55d398326f99059fF775485246999027B3197955',
    pillMLM: '0xA267e31aABB06959BB466059E32B65310dcFf215',
    Owner: '0xD32EF3583cF4A6c0d675D88E847149824f2CBE92',
    withdrawCashFlow:'0x1a0EDEE5f467E31A9341B887b93c3156D844D388'

};
